import { Button, Typography } from '@eventbrite/marmalade';
import styles from './ProgressBar.module.scss';
import { ProgressIndicator } from './ProgressIndicator';

interface ProgressBarProps {
    step: number;
    totalSteps: number;
    text: string;
    layout?: 'inline' | 'block';
}

export const ProgressBar = ({ step, totalSteps, text, layout }: ProgressBarProps) => {
    const progress: number = (step * 100) / totalSteps;

    return (
        <div className={`${layout === 'block' ? styles.blockWrapper : styles.wrapper}`}>
            <div className="eds-text-bs eds-text--center eds-l-pad-right-2">
                <Typography variant="body-md">{text}</Typography>
            </div>
            <div className={`${styles.bar} ${layout === 'block' ? styles.blockBar : ''}`}>
                <ProgressIndicator progress={progress} />
            </div>
        </div>
    );
};
